import React from 'react'
import { MdNoDrinks, MdSmokingRooms, MdGavel } from 'react-icons/md'
import { FaHandHoldingUsd } from 'react-icons/fa'
import styles from './NotAllowed.module.scss'

const items = [
  { id: 'alcohol', text: 'Алкоголь', icon: MdNoDrinks },
  { id: 'tobacco', text: 'Табак', icon: MdSmokingRooms },
  { id: 'lombard', text: 'Ломбарды', icon: FaHandHoldingUsd },
  { id: 'illegal', text: 'Товары нарушающие законодательство', icon: MdGavel },
]

export const NotAllowed: React.FC = () => {
  return (
    <div className={styles.container}>
      <h3 className={styles.title}>Не работаем с</h3>
      <div className={styles.list}>
        {items.map(({ id, text, icon: Icon }) => (
          <div key={id} className={styles.item}>
            <Icon size={18} />
            <span>{text}</span>
          </div>
        ))}
      </div>
    </div>
  )
}
